import Vue from "vue";

const state = {
	showEditTenant: false,
	temporaryTenant: {},
	_tenantlogo_loading: 0,
	tenantinfo: [],
	_tenantinfo_loading: 0,
};

const getters = {
	showEditTenant: (state) => state.showEditTenant,
	getTemporaryTenant: (state) => state.temporaryTenant,
	tenantlogo_loading: (state) => state._tenantlogo_loading !== 0,
	getTenantInfo: (state) => state.tenantinfo,
	tenantinfo_loading: (state) => state._tenantinfo_loading !== 0,
};

const actions = {
	updateTenant({ commit, dispatch }) {
		commit("START_USERLOADING");
		return new Promise((resolve, reject) => {
			axios
				.put("/api/tenant/update-info", state.temporaryTenant)
				.then((res) => {
					if (res.data.object) {
						commit("UPDATE_TENANT_INFO", res.data.object);
						dispatch("hideAction", "hideEditTenant");
					}
					dispatch("handleResponseMessage", res.data);
					resolve(res.data);
				})
				.catch((err) => {
					dispatch("handleError", err);
					reject(err);
				})
				.then(function () {
					commit("STOP_USERLOADING");
				});
		});
	},
	uploadTenantLogo({ commit, dispatch }, formData) {
		commit("START_TENANTLOGO_LOADING");
		const source = axios.CancelToken.source();
		commit("setSource", source);
		commit("setProgress", { total: 100, loaded: 0 });
		return new Promise((resolve, reject) => {
			axios
				.post("/api/tenant/upload-logo", formData, {
					cancelToken: source.token,
					onUploadProgress: (e) => {
						commit("setProgress", { total: e.total, loaded: e.loaded });
					},
				})
				.then((res) => {
					dispatch("fetchUser");
					dispatch("handleResponseMessage", res.data);
					resolve(res.data);
				})
				.catch((err) => {
					dispatch("handleError", err);
					reject(err);
				})
				.then(function () {
					commit("STOP_TENANTLOGO_LOADING");
				});
		});
	},
	fetchTenantInfo({ commit, dispatch }) {
		commit("START_TENANTINFO_LOADING");
		axios
			.get("/api/tenant/info")
			.then((res) => {
				commit("setTenantInfo", res.data);
			})
			.catch((err) => {
				dispatch("handleError", err);
			})
			.then(function () {
				commit("STOP_TENANTINFO_LOADING");
			});
	},
};

const mutations = {
	showEditTenant(state) {
		state.showEditTenant = true;
	},
	hideEditTenant(state) {
		state.showEditTenant = false;
	},
	setTemporaryTenant(state, value) {
		state.temporaryTenant = value;
	},
	START_TENANTLOGO_LOADING(state) {
		state._tenantlogo_loading++;
	},
	STOP_TENANTLOGO_LOADING(state) {
		state._tenantlogo_loading--;
	},
	setTenantInfo(state, value) {
		state.tenantinfo = value;
	},
	START_TENANTINFO_LOADING(state) {
		state._tenantinfo_loading++;
	},
	STOP_TENANTINFO_LOADING(state) {
		state._tenantinfo_loading--;
	},
};

export default {
	state,
	getters,
	actions,
	mutations,
};
